import type { Socket } from 'socket.io-client';
import { io } from 'socket.io-client';
import * as parser from 'socket.io-msgpack-parser';

import { ConnectionId } from '/imports/domain';
import type {
  ClientToServerEvents,
  ServerToClientEvents,
} from '/imports/startup/server/shared/socket';
import { UiSessionState } from '/imports/utils/UiState';

const connectionIdState = UiSessionState.valueProp('id', ConnectionId);

let isLoggedIn = false;

export const connection = {
  get id() {
    return connectionIdState.get();
  },
};

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io('/cx', {
  parser,
  transports: ['websocket'],
  query: connection.id ? { connectionId: connection.id } : undefined,
});

socket.on('initConnection', ({ connectionId, loggedIn }) => {
  // Detect whether the user has been logged out since the last connection
  if (isLoggedIn && !loggedIn) {
    // Prevent subscriptions from reconnecting
    socket.removeAllListeners('connect');
    // Reload to prevent emitting buffered events
    window.location.reload();
  }

  isLoggedIn = loggedIn;

  connectionIdState.set(connectionId);
  console.debug('Socket connection established');
});
